/**
 * Collapsible accordion section for mobile layouts.
 * On desktop (lg+), children render directly without wrapper.
 */

import { useState, ReactNode } from 'react';

interface CollapsibleSectionProps {
  title: string;
  icon: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function CollapsibleSection({ title, icon, children, defaultOpen = false }: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-3 bg-gray-800/60 border border-gray-700 rounded-lg text-sm hover:bg-gray-800/80 transition-colors min-h-[44px]"
      >
        <span className="flex items-center gap-2 text-gray-300 font-medium">
          <span>{icon}</span>
          <span>{title}</span>
        </span>
        <span className="text-gray-500 text-xs">{isOpen ? '▾' : '▸'}</span>
      </button>
      {isOpen && (
        <div className="mt-2">
          {children}
        </div>
      )}
    </div>
  );
}
